module.exports = __webpack_public_path__ + "static/media/customer_icon.f28d00bc.svg";